<template>
  <s-form-list
    formTitle="Create DataDrivenTask"
    title="Variables"
    addLabel="Add Variable"
    :menu-options="variableTypeMenu"
    v-model="variables"
    itemKey="uuid"
    :displayValue="(item?: any) => item?.name || 'Unamed Variable'"
    removeLabel="Remove Variable"
    placeholder="No Variables Added"
    removable
    confirmRemove
  >
    <template #item="{item: variable, index: i}">
      <div class="p-5">
        <number-variable-input
          v-if="isNumberVariable(variable)"
          :name="variable.name"
          @update:name="updateVariableValue(i, 'name', $event)"
          :min="variable.min"
          @update:min="updateVariableValue(i, 'min', $event)"
          :max="variable.max"
          @update:max="updateVariableValue(i, 'max', $event)"
          :shift="variable.shift"
          @update:shift="updateVariableValue(i, 'shift', $event)"
          :step="variable.step"
          @update:step="updateVariableValue(i, 'step', $event)"
          :include-zero="variable.includeZero"
          @update:include-zero="updateVariableValue(i, 'includeZero', $event)"
          :scientific-notation="variable.scientificNotation"
          @update:scientific-notation="updateVariableValue(i, 'scientificNotation', $event)"
          :errors="errors?.[i]"
        />
        <string-choice-variable-input
          v-else-if="isStringVariable(variable)"
          :name="variable.name"
          @update:name="updateVariableValue(i, 'name', $event)"
          :options="variable.options"
          @update:options="updateVariableValue(i, 'options', $event)"
          :errors="errors?.[i]"
        />
      </div>
    </template>
  </s-form-list>
</template>

<script setup lang="ts">
import NumberVariableInput from './NumberVariableInput.vue';
import SFormList from '../../../../design-system/SFormList.vue';
import {computed, ref, toRef, watch} from 'vue';
import StringChoiceVariableInput from './StringChoiceVariableInput.vue';
import {AnyTaskVariableDto} from '../../../../types/entities/tasks';
import {useVariableTypeLibrary} from '../../../../variables/useVariableTypeLibrary';
import {useI18n} from 'vue-i18n';

const props = defineProps<{
  numberOnly?: boolean;
  errors?: Record<string, any>;
}>();

const variables = defineModel<AnyTaskVariableDto[]>('variables', {default: []});

const {t} = useI18n();

const {variableTypes, isStringVariable, isNumberVariable} = useVariableTypeLibrary();

const variableTypeMenu = computed(() =>
  variableTypes
    .filter(({type}) => !props.numberOnly || type === 'Number')
    .map((variableType) => ({
      label: t(`variables.${variableType.type}.label`),
      icon: variableType.icon,
      onClick: () => {
        variables.value.push(variableType.create());
      },
    }))
);

function updateVariableValue(index: number, key: string, value: any) {
  // @ts-expect-error it's hard to type this properly given the union type of variable types
  variables.value[index][key] = value;
}
</script>
